<template lang="pug">
span.article-title-field
  b-input(
    v-show="settings.editing"
    ref="field"
    v-model="title"
    @blur="toggle"
  )
  a.is-size-5(
    v-show="!settings.editing"
    @click="toggle"
  ) {{ title }}
</template>

<script>
import { mapGetters } from 'vuex';
import * as getters from '@/store/types/getters';

export default {
  name: 'article-title-field',
  computed: {
    ...mapGetters({
      article: getters.GET_ARTICLE,
    }),
  },
  created() {
    this.title = this.value;
  },
  data() {
    return {
      title: null,
      settings: {
        editing: false,
      },
    };
  },
  methods: {
    toggle() {
      this.settings.editing = !this.settings.editing;
      if (this.settings.editing) {
        this.$refs.field.focus();
      } else {
        this.$emit('input', this.title);
      }
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  watch: {
    value(val) {
      this.title = val;
    },
  },
};
</script>

<style lang="scss">
.article-title-field {
  a {
    position: relative;
    top: 5px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      text-decoration: underline;
      color: $theme-primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/article/ArticleTitleField.vue